import { proxy } from 'comlink';
import { AbstractVideoEngine } from './AbstractVideoEngine';
import { VideoFrameExtractor } from './VideoFrameExtractor';
export class ChromeVideoEngine extends AbstractVideoEngine {
    LOG_PREFIX = '[ChromeVideoEngine]';
    videoFrameExtractors = new Map();
    constructor() {
        super();
        console.log(`${this.LOG_PREFIX} constructor called`);
    }
    async onDestroy() {
        for (const videoFrameExtractor of this.videoFrameExtractors.values()) {
            await videoFrameExtractor.stop();
        }
        this.videoFrameExtractors.clear();
    }
    async addMediaStreamVideoTrack(track) {
        console.log(`${this.LOG_PREFIX} addMediaStreamVideoTrack called`, {
            trackId: track.id,
        });
        const videoFrameExtractor = new VideoFrameExtractor(track);
        videoFrameExtractor.emitter.on('aborted', () => {
            console.log(`${this.LOG_PREFIX} videoFrameExtractor aborted, cleaning up track`, { trackId: track.id });
            this.videoFrameExtractors.delete(track.id);
            console.log(`${this.LOG_PREFIX} track removed from main thread, remaining tracks: ${this.videoFrameExtractors.size}`, { trackId: track.id });
        });
        this.videoFrameExtractors.set(track.id, videoFrameExtractor);
        console.log(`${this.LOG_PREFIX} adding unencoded video track to encoder worker, total tracks: ${this.videoFrameExtractors.size}`);
        const outputTrack = videoFrameExtractor.getOutputTrack();
        await this.videoEncoderWorkerProxy?.addVideoEncoder(proxy(outputTrack));
        console.log(`${this.LOG_PREFIX} starting videoFrameExtractor`);
        await videoFrameExtractor.start();
        console.log(`${this.LOG_PREFIX} addMediaStreamVideoTrack completed`, {
            trackId: track.id,
        });
    }
    async removeMediaStreamVideoTrack(track) {
        console.log(`${this.LOG_PREFIX} removeMediaStreamVideoTrack called`, {
            trackId: track.id,
        });
        this.videoFrameExtractors.get(track.id)?.stop();
        console.log(`${this.LOG_PREFIX} removeMediaStreamVideoTrack completed`, {
            trackId: track.id,
        });
    }
}
